import { SLICER_KEYS } from 'types/services';
import { createSlice } from '@reduxjs/toolkit';

import type { NavigationStateStore } from './types';
import { setState } from './reducers/setState';
import { removeState } from './reducers/removeState';
import { resetState } from './reducers/resetState';
import { updateState } from './reducers/updateState';
import { clearStaleStates } from './reducers/clearStaleStates';

const initialState: NavigationStateStore = {};

export const navigationState = createSlice({
  name: SLICER_KEYS.NAVIGATION_STATE,
  initialState,
  reducers: {
    setState,
    removeState,
    resetState,
    updateState,
    clearStaleStates,
  },
});

export const navigationStateActions = navigationState.actions;
